"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_MIN_LENGTH = void 0;
const SEARCH_MIN_LENGTH = exports.SEARCH_MIN_LENGTH = 2;